import React from 'react';
import { useAppConfig } from '../AppConfig';

const headingStyle: React.CSSProperties = {
    width: '150px',
};

type ResultGroupProps = {
    children?: React.ReactNode;
    className?: string;
    heading: string;
    headingClass: string;
};

export function ResultGroup(props: ResultGroupProps) {
    const { children, className = '', heading, headingClass } = props;

    const { isLandingPage } = useAppConfig();

    const groupingBase = `mb-24 ${
        isLandingPage ? 'sm:flex sm:items-baseline sm:space-x-16 sm:mb-16' : ''
    }`;
    const headingBase = isLandingPage
        ? 'sm:shrink-0 sm:text-m sm:font-normal'
        : '';

    return (
        <div className={`${groupingBase} ${className}`}>
            <h3
                className={`${headingBase} ${headingClass}`}
                style={isLandingPage ? headingStyle : undefined}
            >
                {heading}
            </h3>
            {isLandingPage ? <div className="grow">{children}</div> : children}
        </div>
    );
}
